export const aciEnd = {
    iconName: 'end',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 21 21' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M18 1.5H3A1.5 1.5 0 001.5 3v15A1.5 1.5 0 003 19.5h15a1.5 1.5 0 001.5-1.5V3A1.5 1.5 0 0018 1.5zM3 0a3 3 0 00-3 3v15a3 3 0 003 3h15a3 3 0 003-3V3a3 3 0 00-3-3H3z',
                fill: 'currentColor',
            },
        },
    },
};
